import React from 'react'
import SearchNot from '../images/searchNot.png'
const EmptyReturn = ({w=300,h=300}) => {
  return (
    <div  className='d-flex flex-column align-items-center m-auto'><img width={w} height={h} src={SearchNot}/><h4 style={{margin:'-12px auto'}}> چیزی پیدا نکردم !</h4></div>
  )
}

export default EmptyReturn
